module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/tasks/patientprofile-view/patientprofile-view.component.css
// module id = ./src/app/Pages/tasks/patientprofile-view/patientprofile-view.component.css
// module chunks = main